import theme from '@adsk/alloy-react-theme';
import { RfiStatus } from '../sdk/types';

export const getStatusColorMapping = (serverStatus: RfiStatus) => {
  const colorsMap = {
    [RfiStatus.Draft]: theme.colors.charcoal900,
    [RfiStatus.Submitted]: theme.colors.adskBlue500,
    [RfiStatus.Open]: theme.colors.yellowOrange500,
    [RfiStatus.OpenRev1]: theme.colors.yellowOrange500,
    [RfiStatus.OpenRev2]: theme.colors.yellowOrange500,
    [RfiStatus.Answered]: theme.colors.yellowOrange500,
    [RfiStatus.AnsweredRev1]: theme.colors.yellowOrange500,
    [RfiStatus.AnsweredManager]: theme.colors.yellowOrange500,
    [RfiStatus.Closed]: theme.colors.charcoal200,
    [RfiStatus.Void]: theme.colors.charcoal500,
  };
  return colorsMap[serverStatus];
};
